export default __webpack_public_path__ + "static/media/threeMedals.63c031d1.png";